export interface Options {
  actionsFormUrl: string;
}

export const OptionsCollectionPath = 'options';
